module.exports = __webpack_public_path__ + "media/pdf/resq-39f94e93.png";